import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { map } from 'rxjs/operators';
import { License} from './models/license';
import { environment } from '../environments/environment';
import { AuthService } from './auth.service';

@Injectable()
export class LicenseService {
  href: string = environment.license_api;
  headers: HttpHeaders;

  constructor(
    private http: HttpClient,
    private authSvc: AuthService,
) {
  this.headers = new HttpHeaders({
    Authorization: 'jwt_token ' + this.authSvc.getAccountsToken(),
  });
  this.authSvc.token$.subscribe(
    () => { this.headers = new HttpHeaders({ Authorization: 'jwt_token ' + this.authSvc.getAccountsToken() }); },
    (err) => { console.error('token subject error', err); },
    () => { console.log('token subject complete'); },
  );
}

  GetLicensesForDevice(deviceId: number): Observable<any> {
    const requestUrl =
      `${this.href}/admin/v1/device/${deviceId}/licenses`;
    return this.http.get<any>(requestUrl, { headers: this.headers });
  }

  DelinkDeviceFromLicense(licenseId: number): Observable<any> {
    const requestUrl =
      `${this.href}/admin/v1/license/${licenseId}/delink_device`;
    return this.http.delete<any>(requestUrl, { headers: this.headers });
  }

  getLicenses(): Observable<any> {
    const requestUrl =
      `${this.href}/admin/v1/licenses`;

    return this.http.get<any>(requestUrl, { headers: this.headers }).pipe(
      map((d: any) => d.licenses)
    );
  }

  LinkLicenseToDevice(licenseId: number, deviceId: number, accountID?: number): Observable<any> {
    const requestUrl =
      `${this.href}/admin/v1/device/license/link`;

    return this.http.post<any>(
      requestUrl,
      { license_id: +licenseId, device_id: deviceId, account_id: accountID },
      { headers: this.headers },
    );
  }

  saveLicense(l: License): Observable<any> {
    const requestUrl =
      `${this.href}/admin/v1/license`;

    return this.http.post<any>(requestUrl, { license: l }, { headers: this.headers });
  }

  patchActive(licenseID: number, accountID: number, newActive: boolean): Observable<any> {
    const reqURL = `${this.href}/admin/v1/license/${licenseID}/active`;
    const body = { account_id: accountID, active: newActive };
    return this.http.patch(reqURL, body, { headers: this.headers });
  }

  patchExpires(licenseID: number, accountID: number, newExpires?: Date): Observable<any> {
    const reqURL = `${this.href}/admin/v1/license/${licenseID}/expires`;
    const body = { account_id: accountID, expires: newExpires ? Math.floor(newExpires.getTime() / 1000) : null };
    return this.http.patch(reqURL, body, { headers: this.headers });
  }
}



// WEBPACK FOOTER //
// ./src/app/license.service.ts